/**
 * Merge a persisted order with the sections actually present. Keeps the stored
 * order for sections that still exist, drops any that no longer do, and appends
 * newly-introduced sections in their default position — so adding a section type
 * later doesn't strand it off-screen for advisors with a saved order. Duplicate
 * ids (from manual edits or legacy writes) collapse to first-seen to avoid React
 * key collisions downstream.
 */
export function reconcileSectionOrder(stored: readonly string[], present: readonly string[]): string[] {
  const presentSet = new Set(present);
  const seen = new Set<string>();
  const order: string[] = [];
  for (const id of [...stored, ...present]) {
    if (presentSet.has(id) && !seen.has(id)) {
      seen.add(id);
      order.push(id);
    }
  }
  return order;
}
